import * as Types from '../../types/bff/gql-schema';

import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const UserMissionsDocument = `
    query UserMissions {
  userMissions {
    missionRecords {
      completionCount
      completedAt
      mission {
        id
        endAt
        name
        periodType
        quantity
        startAt
        ticketType
        type
        visible
        targetLink
        maxCount
      }
      status
    }
    userId
    userTickets {
      id
      quantity
      ticketType
      userId
    }
  }
}
    `;
export const useUserMissionsQuery = <
      TData = Types.UserMissionsQuery,
      TError = Types.GraphqlError
    >(
      variables?: Types.UserMissionsQueryVariables,
      options?: UseQueryOptions<Types.UserMissionsQuery, TError, TData>,
    ) =>
    useQuery<Types.UserMissionsQuery, TError, TData>(
      variables === undefined ? ['UserMissions'] : ['UserMissions', variables],
      gqlFetcher<Types.UserMissionsQuery, Types.UserMissionsQueryVariables>(UserMissionsDocument, 'UserMissions', variables),
      options
    );

useUserMissionsQuery.getKey = (variables?: Types.UserMissionsQueryVariables) => variables === undefined ? ['UserMissions'] : ['UserMissions', variables];
;

useUserMissionsQuery.fetcher = (variables?: Types.UserMissionsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.UserMissionsQuery, Types.UserMissionsQueryVariables>(UserMissionsDocument, 'UserMissions', variables, options);
export const CompleteMissionDocument = `
    mutation CompleteMission($request: MissionCompleteRequestInput!) {
  completeMission(request: $request)
}
    `;
export const useCompleteMissionMutation = <
      TError = Types.GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.CompleteMissionMutation, TError, Types.CompleteMissionMutationVariables, TContext>) =>
    useMutation<Types.CompleteMissionMutation, TError, Types.CompleteMissionMutationVariables, TContext>(
      ['CompleteMission'],
      (variables?: Types.CompleteMissionMutationVariables) => gqlFetcher<Types.CompleteMissionMutation, Types.CompleteMissionMutationVariables>(CompleteMissionDocument, 'CompleteMission', variables)(),
      options
    );
useCompleteMissionMutation.fetcher = (variables: Types.CompleteMissionMutationVariables, options?: RequestInit['headers']) => gqlFetcher<Types.CompleteMissionMutation, Types.CompleteMissionMutationVariables>(CompleteMissionDocument, 'CompleteMission', variables, options);
export const UserGamePrizeDocument = `
    query UserGamePrize($gameType: GameType!) {
  userGamePrizes(gameType: $gameType) {
    activePrizeStrategies {
      gameType
      id
      prize {
        amount
        displayName
        id
        name
        type
        thumbnailUrl
        formattedGuidance
        winningImageUrl
      }
      quantity
    }
    gameType
    userId
    userPrizes {
      drawnAt
      id
      prize {
        amount
        displayName
        id
        name
        type
        thumbnailUrl
        formattedGuidance
        winningImageUrl
      }
      quantity
      receivedAt
      status
      userId
    }
  }
}
    `;
export const useUserGamePrizeQuery = <
      TData = Types.UserGamePrizeQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.UserGamePrizeQueryVariables,
      options?: UseQueryOptions<Types.UserGamePrizeQuery, TError, TData>,
    ) =>
    useQuery<Types.UserGamePrizeQuery, TError, TData>(
      ['UserGamePrize', variables],
      gqlFetcher<Types.UserGamePrizeQuery, Types.UserGamePrizeQueryVariables>(UserGamePrizeDocument, 'UserGamePrize', variables),
      options
    );

useUserGamePrizeQuery.getKey = (variables: Types.UserGamePrizeQueryVariables) => ['UserGamePrize', variables];
;

useUserGamePrizeQuery.fetcher = (variables: Types.UserGamePrizeQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.UserGamePrizeQuery, Types.UserGamePrizeQueryVariables>(UserGamePrizeDocument, 'UserGamePrize', variables, options);
export const DrawPrizeDocument = `
    mutation DrawPrize($request: PrizeDrawRequestInput!) {
  drawPrize(request: $request) {
    prize {
      amount
      displayName
      id
      name
      type
      thumbnailUrl
      formattedGuidance
      winningImageUrl
    }
    quantity
    userPrizeId
  }
}
    `;
export const useDrawPrizeMutation = <
      TError = Types.GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.DrawPrizeMutation, TError, Types.DrawPrizeMutationVariables, TContext>) =>
    useMutation<Types.DrawPrizeMutation, TError, Types.DrawPrizeMutationVariables, TContext>(
      ['DrawPrize'],
      (variables?: Types.DrawPrizeMutationVariables) => gqlFetcher<Types.DrawPrizeMutation, Types.DrawPrizeMutationVariables>(DrawPrizeDocument, 'DrawPrize', variables)(),
      options
    );
useDrawPrizeMutation.fetcher = (variables: Types.DrawPrizeMutationVariables, options?: RequestInit['headers']) => gqlFetcher<Types.DrawPrizeMutation, Types.DrawPrizeMutationVariables>(DrawPrizeDocument, 'DrawPrize', variables, options);
export const ReceivePrizeDocument = `
    mutation ReceivePrize($request: PrizeReceiveRequestInput!) {
  receivePrize(request: $request)
}
    `;
export const useReceivePrizeMutation = <
      TError = Types.GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.ReceivePrizeMutation, TError, Types.ReceivePrizeMutationVariables, TContext>) =>
    useMutation<Types.ReceivePrizeMutation, TError, Types.ReceivePrizeMutationVariables, TContext>(
      ['ReceivePrize'],
      (variables?: Types.ReceivePrizeMutationVariables) => gqlFetcher<Types.ReceivePrizeMutation, Types.ReceivePrizeMutationVariables>(ReceivePrizeDocument, 'ReceivePrize', variables)(),
      options
    );
useReceivePrizeMutation.fetcher = (variables: Types.ReceivePrizeMutationVariables, options?: RequestInit['headers']) => gqlFetcher<Types.ReceivePrizeMutation, Types.ReceivePrizeMutationVariables>(ReceivePrizeDocument, 'ReceivePrize', variables, options);